import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request table view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Extending the summTreeColumn filter to calculate and display summary values
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting the result based on the column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with the formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending from the existing summColumn filter
        );

        // Returning the layout configuration for the view
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'BetShopName', // Column ID
                                    header: _('Punto de Venta'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ActionTittle', // Column ID for actions
                                    header: '', // No header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    hidden: !devConfig.getPermAction(
                                        // Conditional visibility based on permissions
                                        'withdrawalRequestsBetShop',
                                        'Edit',
                                    ),
                                    css: 'prm-withdrawalRequestsBetShop', // CSS class for styling
                                    template: function (obj) {
                                        // Template function for rendering action buttons
                                        if (obj.State == 'A') {
                                            return "<span placeholder='Aprobar' class='webix_icon wxi-close approve'></span><span class='webix_icon wxi-close torefuse'></span>";
                                        } else {
                                            if (obj.State == 'P') {
                                                return "<span placeholder='Pagar' class='webix_icon wxi-close pay'></span>";
                                            } else {
                                                return '';
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'detailTittle', // Column ID for details
                                    header: '', // No header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip with localization
                                    template: function (obj) {
                                        // Template function for rendering detail button
                                        return "<span class='webix_icon wxi-close details'></span>";
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for ID
                                    header: 'Id', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId', // Column ID for client ID
                                    header: _('ID Cliente'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID for amount
                                    header: _('Valor'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.Number.numToStr({
                                        // Formatting function for numbers
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2,
                                    }),
                                    footer: { content: 'summColumn' }, // Footer content
                                    editor: 'text', // Editor type
                                },
                                {
                                    id: 'State', // Column ID for state
                                    header: _('Estado'), // Column header with localization
                                    options: [
                                        // Options for state selection
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Pagada') },
                                        { id: 'E', value: _('Eliminado') },
                                        { id: 'P', value: _('Pendiente') },
                                        { id: 'R', value: _('Rechazado') },
                                    ],
                                },
                                {
                                    id: 'CreatedLocal', // Column ID for creation date
                                    header: _('Fecha Creación'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PaymentDate', // Column ID for payment date
                                    header: _('Fecha Pagado'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ByAllowDate', // Column ID for allowed date
                                    header: _('Por fecha de retiro pagado'), // Column header with localization
                                    options: [
                                        // Options for yes/no selection
                                        { id: '0', value: _('No') },
                                        { id: '1', value: _('Sí') },
                                    ],
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                details: function (euv, id) {
                                    // Handler for details button click
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                    if (screen.width < 500 || screen.height < 500) {
                                        // Responsive handling
                                        $$('windowDetailsWithdrawal').show(); // Show details window
                                    } else {
                                        $$('dColl').expand(); // Expand details section
                                        $$('a5').scrollTo(0, 500); // Scroll to details
                                    }
                                },
                                pay: function (euv, id) {
                                    // Handler for pay button click
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        // Confirmation dialog for payment
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Pagar Nota de Retiro?'),
                                        ok: _('Pagar Nota'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation
                                            if (action === true) {
                                                // If confirmed
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax() // AJAX request to pay withdrawal request
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/PayWithdrawalRequests',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                // Error handler
                                                                webix.message(_('Error! '));
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                // Success handler
                                                                item.State = 'I'; // Update item state
                                                                webix.message(_('Nota de Retiro Pagada')); // Success message
                                                                vvthis.$$('table').clearAll(); // Clear the table
                                                                vvthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                approve: function (euv, id) {
                                    // Handler for approve button click
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        // Confirmation dialog for approval
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Nota de Retiro?'),
                                        ok: _('Aprobar Nota'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation
                                            if (action === true) {
                                                // If confirmed
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax() // AJAX request to approve withdrawal request
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/AllowWithdrawalRequests',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                // Error handler
                                                                webix.message(_('Error! '));
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                // Success handler
                                                                item.State = 'P'; // Update item state
                                                                webix.message(_('Nota de Retiro Aprobado')); // Success message
                                                                vvthis.$$('table').clearAll(); // Clear the table
                                                                vvthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                torefuse: function (euv, id) {
                                    // Handler for refuse button click
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        // Confirmation dialog for refusal
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Rechazar Nota de Retiro?'),
                                        ok: _('Rechazar Nota'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation
                                            if (action === true) {
                                                // If confirmed
                                                var item = vvthis.getItem(id); // Get the clicked item
                                                webix
                                                    .ajax() // AJAX request to cancel withdrawal request
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/CancelClientRequests',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                // Error handler
                                                                webix.message(_('Error! '));
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                // Success handler
                                                                item.State = 'E'; // Update item state
                                                                webix.message(_('Nota de Retiro Rechazada')); // Success message
                                                                vvthis.$$('table').clearAll(); // Clear the table
                                                                vvthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            editable: true, // Enable editing
                            footer: true, // Show footer
                            math: true, // Enable math calculations
                            loadahead: 0, // Load ahead setting
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch setting
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        grid = $$('datatable'); // Reference to the data table
        var url = devConfig.geturlApi() + 'es/Client/GetClientWithdrawalRequests2'; // API URL for fetching data
        var filter = ''; // Variable to hold filter string

        // Event listener for filtering withdrawal reports
        this.on(this.app, 'withdrawalReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data into the grid
            $$('filterPopup').hide(); // Hide the filter popup
            filter = string1; // Update the filter variable
        });

        // Event listener for sorting the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event listener for starting edit on a cell
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id); // Get the item being edited
            console.log(item);
            if (id.column == 'Action') {
                // Check if editing the Action column
                var options = this.getColumnConfig('Action').collection; // Get action options
                if (item.State == 'A') {
                    options.remove('P'); // Remove 'Pay' option if state is 'A'
                } else if (item.State == 'P') {
                    options.remove('A'); // Remove 'Approve' option if state is 'P'
                } else {
                    return false; // Prevent editing for other states
                }
                console.log(id);
            }
        });

        // Event listener for stopping edit on a cell
        grid.attachEvent('onAfterEditStop', function (state, editor, ignoreUpdate) {
            console.log(state);
            var item = this.getItem(editor.row); // Get the edited item
            console.log(item);
            if (state.value != state.old) {
                // Check if the value has changed
                if (state.value == 'A') {
                    // If approved
                    webix
                        .ajax() // AJAX request to approve withdrawal request
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/AllowWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                // Error handler
                                webix.message(_('Error! '));
                            },
                            success: function (text, data, XmlHttpRequest) {
                                // Success handler
                                item.State = 'P'; // Update item state
                                webix.message('Cell value was changed'); // Message for value change
                            },
                        });
                }
                if (state.value == 'P') {
                    // If paid
                    webix
                        .ajax() // AJAX request to pay withdrawal request
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/PayWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                // Error handler
                                webix.message(_('Error! '));
                            },
                            success: function (text, data, XmlHttpRequest) {
                                // Success handler
                                item.State = 'I'; // Update item state
                                webix.message('Cell value was changed'); // Message for value change
                            },
                        });
                }
                if (state.value == 'E') {
                    // If canceled
                    webix
                        .ajax() // AJAX request to cancel withdrawal request
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/CancelClientRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                // Error handler
                                webix.message(_('Error! '));
                            },
                            success: function (text, data, XmlHttpRequest) {
                                // Success handler
                                item.State = 'E'; // Update item state
                                webix.message('Cell value was changed'); // Message for value change
                            },
                        });
                }
            }
        });

        // Event listener for selecting a player
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                // Load data for the selected player
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id,
            );
        });
    }
}

// FILE DOCUMENTED
